import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CloneService } from '../../../services/clone.service';

import { DatatableComponent } from './datatable.component';
import { DatatableSortingDirective } from './shared/datatable-sorting.directive';
import { LegfiCurrencyPipe } from '../../../pipes/format/legfi-currency.pipe';
import { LegfiCurrencyPipeModule } from '../../../pipes/format/legfi-currency.module';
import { DatatableSearchComponent } from './datatable-search/datatable-search.component';

@NgModule({
    imports: [
        CommonModule,
        LegfiCurrencyPipeModule,
    ],
    declarations: [
        DatatableComponent,
        DatatableSearchComponent,
        DatatableSortingDirective,
    ],
    exports: [
        DatatableComponent,
        DatatableSearchComponent,
        DatatableSortingDirective,
    ],
    providers: [
        // Services
        CloneService,
        // Pipes
        LegfiCurrencyPipe,
    ],
})
export class DatatableModule
{
}
